import { render, staticRenderFns } from "./transactionPeriodMamSub.vue?vue&type=template&id=50d37796&scoped=true"
import script from "./transactionPeriodMamSub.vue?vue&type=script&lang=js"
export * from "./transactionPeriodMamSub.vue?vue&type=script&lang=js"
import style0 from "./transactionPeriodMamSub.vue?vue&type=style&index=0&id=50d37796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d37796",
  null
  
)

export default component.exports